import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
 import Header from "../layout/header";
import Footer from "../layout/footer";
import { history } from "../../store";
import { getblocks, getOutlets, getPage } from "../../stores/cms";
var parse = require('html-react-parser');

class Contactus extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "About Page"
    };
  }
  componentWillMount() {

    this.props.getblocks();
    this.props.getOutlets();
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    var pageSlug = this.props.match.params.pageSlug;
    this.props.getPage(pageSlug);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {


    var pageSlug = this.props.match.params.pageSlug;
    if (prevProps.match.params.pageSlug !== pageSlug
    ) {
      window.scrollTo(0, 0);
      this.props.getPage(pageSlug);
    }
  }
  render() {
    const pages = this.props.pages;
    if (this.props.pageStatus === "error") {
      //history.push("/");
    }
    return (
      <React.Fragment>
         <Header allProps={this.props} /> 
        <div className="main-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="page-header-block bg-transparent">
                  <h1 className="font-gothamlight  text-center text-uppercase">
                    contact us
                  </h1>
                  {/* <h2 className="font-azakie text-center">
                    You can update your account details and check order status
                    here
                  </h2> */}
                  <nav
                    aria-label="breadcrumb"
                    className="d-flex justify-content-center"
                  >
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to="/">Home</Link>
                      </li>
                      <li
                        className="breadcrumb-item active"
                        aria-current="page"
                      >
                        contact us
                      </li>
                    </ol>
                  </nav>
                </div>
              </div>
              <div className="col-12 cms-page-container contact">
              <div class="row">
              <div className="col-12 col-md-6 mx-auto  align-items-center ">
                        <h4 className="title3">CONTACT US</h4>
                        <p>
                          <b>Reservation Hotline:</b>
                          <br />
                          <a href="tel:+6564495030">+65 6449-5030</a></p>
                        <p>
                          <b>Whatsapp Messenger</b>
                          <br />
                          <a href="tel:+6594615828">+65 9461-5828</a>
                        </p>
                        <p className="open-hours">
                          <b>Address :</b>
                          <br />52-56 Upper Cross Street, Singapore 058348
                          <br />(Opposite Chinatown Point carpark)
                        </p>
                  </div>
                  <div className="col-12 col-md-6 mx-auto align-items-center ">
                      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.815952022!2d103.84234061475391!3d1.284351299063239!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da197355dfcfdd%3A0xe1fddd348d1c9f78!2sSpring%20Court%20-%20Celebrating%20Singaporean%20Chinese%20Cuisine%20Since%201929!5e0!3m2!1sen!2sin!4v1581615669913!5m2!1sen!2sin"   width="600" height="250" frameborder="0" style={{border:0}}  allowfullscreen=""></iframe>
                  </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
        <Footer allProps={this.props} />
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ cms }) => ({
  staticblocks: cms.staticblocks,
  cmsFetch: cms.cmsFetch,
  outlets: cms.outlets,
  pages: cms.pages,
  pageStatus: cms.pageStatus
});
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getblocks,
      getOutlets,
      getPage
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Contactus);
